"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.PermissionUserOverrides_Factory = exports.Date_Factory = void 0;
var Date_Factory_1 = require("./Date_Factory");
Object.defineProperty(exports, "Date_Factory", { enumerable: true, get: function () { return Date_Factory_1.Date_Factory; } });
var PermissionRestrictionPoint_1 = require("./PermissionRestrictionPoint");
var PermissionUserOverrides_Factory = /** @class */ (function () {
    function PermissionUserOverrides_Factory() {
    }
    PermissionUserOverrides_Factory.CreateIncoming = function (model) {
        if (!model)
            return model;
        var result = {
            PermissionBehaviour: model.PermissionBehaviour,
            PermissionRestrictionPoint: PermissionRestrictionPoint_1.PermissionRestrictionPoint_Factory.CreateIncoming(model.PermissionRestrictionPoint),
            PermissionRestrictionPointId: model.PermissionRestrictionPointId,
            RecordCreated: Date_Factory_1.Date_Factory.CreateIncoming(model.RecordCreated),
            RecordId: model.RecordId,
            RecordLastUpdated: Date_Factory_1.Date_Factory.CreateIncoming(model.RecordLastUpdated),
            RecordStatus: model.RecordStatus,
            UserId: model.UserId,
        };
        return result;
    };
    PermissionUserOverrides_Factory.CreateOutgoing = function (model) {
        if (!model)
            return model;
        var result = {
            PermissionBehaviour: model.PermissionBehaviour,
            PermissionRestrictionPoint: PermissionRestrictionPoint_1.PermissionRestrictionPoint_Factory.CreateOutgoing(model.PermissionRestrictionPoint),
            PermissionRestrictionPointId: model.PermissionRestrictionPointId,
            RecordCreated: Date_Factory_1.Date_Factory.CreateOutgoing(model.RecordCreated),
            RecordId: model.RecordId,
            RecordLastUpdated: Date_Factory_1.Date_Factory.CreateOutgoing(model.RecordLastUpdated),
            RecordStatus: model.RecordStatus,
            UserId: model.UserId,
        };
        return result;
    };
    return PermissionUserOverrides_Factory;
}());
exports.PermissionUserOverrides_Factory = PermissionUserOverrides_Factory;
